<template>
  <div style="height: 100vh">
    <div class="my-purchases-search hidden-xs-only">
      <el-input
        placeholder="Buscar">
        <i
          slot="prepend"
          class="icon-search-icon"/>
        <el-button
          slot="append">
          <i class="icon-filter-icon"/>
          Filtrar
        </el-button>
      </el-input>
    </div>
    <el-row class="address-row">
      <el-col
        :span="18"
        class="name-owner">
        <b>Arturo Emmanuel Reséndiz Aguilar</b>
      </el-col>
      <el-col
        :span="5"
        class="place-owner">
        <span>Querétaro, México</span>
      </el-col>
      <el-col
        :span="1"
        class="link-owner">
        <i class="icon-right-arrow"/>
      </el-col>
    </el-row>
    <el-row class="address-row">
      <el-col
        :span="18"
        class="name-owner">
        <b>Maquinaria pesada y Herrajes del Bajío de México SA de CV</b>
      </el-col>
      <el-col
        :span="5"
        class="place-owner">
        <span>Querétaro, México</span>
      </el-col>
      <el-col
        :span="1"
        class="link-owner">
        <i class="icon-right-arrow"/>
      </el-col>
    </el-row>
    <router-link :to="{name: 'addInvoice'}">
      <el-button class="btn-add-direction">Agregar otra dirección</el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Invoice'
}
</script>

<style lang="scss" scoped>

  .address-row{
    background-color: white;
    height: 50px;
    display: flex;
    align-items: center;
    margin-bottom: 3px;
  }

  .name-owner {
    padding-left: 20px;
  }

  .link-owner {
    border-left: 1px solid $content;
    height: 50px;
    display: flex;
    align-items: center;
    i{
      margin: 0 auto;
      font-size: 14px;
      color: $roseHeader;
      font-weight: bold;
    }
  }
  .place-owner{
    text-align: right;
    padding-right: 40px;
  }
.btn-add-direction{
  margin-top: 5px;
  background-color: $roseHeader;
  border: none;
  border-radius: 2px;
  color: white;
  @include font-primary(12px, bold);
}
</style>



// WEBPACK FOOTER //
// src/components/user-profile/invoice.vue